/** @jsxImportSource @emotion/react */
import "./shared/styles/App.css";
import "./shared/styles/themeCustomization.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import { BrowserRouter } from "react-router-dom";
import { Estetica, FooterMorfeo } from "./shared";
import Router from "./Router";
import { PrimeReactProvider } from "primereact/api";

export default function App() {
  return (
    <PrimeReactProvider>
      <Estetica app="COLABORADOR">
      <BrowserRouter>
        <div
          // Columna del alto de la ventana: como el footer tiene margin-top
          // auto, queda abajo de todo aunque el contenido no llene la pantalla.
          css={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh"
          }}
        >
          <div
            // El contenido va en su propio div y no suelto en la columna
            // flex: App.css le da `margin: auto` horizontal a <main>, y en un
            // flex container los márgenes auto anulan el stretch y lo
            // encogerían al ancho del texto.
            css={{ flex: "1 0 auto" }}
          >
            <Router />
          </div>
          <FooterMorfeo />
        </div>
      </BrowserRouter>
    </Estetica>
    </PrimeReactProvider>
  );
}
